import type { FocusEvent } from "react";
import type { ButtonsSelectProps, Data, DataGroupItem } from "./ButtonSelect";

export const isDataGroupItemGroup = (data?: Data): data is DataGroupItem[] =>
  Boolean(
    data && data.length > 0 && typeof data[0] !== "string" && "group" in data[0]
  );

// onBlur bubbles, so only report a blur once focus leaves the whole control,
// not when it moves from one option to the next.
export const handleGroupBlur =
  (onBlur?: () => void) => (event: FocusEvent<HTMLElement>) => {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      onBlur?.();
    }
  };

export const getNextValue = (
  itemValue: string,
  { value, allowDeselect }: Pick<ButtonsSelectProps, "value" | "allowDeselect">
) => (value === itemValue && allowDeselect ? undefined : itemValue);
